import { RadioButtonRow } from 'folio-common-components';
import * as React from 'react';
import type { WillHaveEmployees } from '../../gqltypes';
import { type RootState, useActions, useSelector } from '../../state';
import { msgsToComponents } from '../../utils/msgs-to-components';

const msgs = {
  EmployedExplanation: 'Dette inkluderer deg selv, om du tar ut lønn.',
  EmployeesYes: 'Ja',
  EmployeeYesN: {
    single: 'Ja, men bare meg',
    multiple: 'Ja, men bare eierne',
  },
  EmployeesNo: 'Nei',
};

const Msg = msgsToComponents(msgs);

function selector(state: RootState) {
  return {
    willHaveEmployees: state.editor.coreInfo.willHaveEmployees,
    ownershipType: state.editor.ownershipType,
  };
}

export const EmploymentForm: React.FC = () => {
  const { ownershipType, willHaveEmployees } = useSelector(selector);
  const { editorActions } = useActions();
  const onChange = (employees: WillHaveEmployees) =>
    editorActions.setCoreInfo({ willHaveEmployees: employees });

  return (
    <>
      <RadioButtonRow
        inputProps={{
          checked: willHaveEmployees === 'NO',
          onChange: () => onChange('NO'),
          name: 'willHaveEmployees',
        }}
        id="willHaveEmployeesNo"
        label={<Msg.EmployeesNo />}
      />

      <RadioButtonRow
        inputProps={{
          checked: willHaveEmployees === 'YES',
          onChange: () => onChange('YES'),
          name: 'willHaveEmployees',
        }}
        id="willHaveEmployeesYes"
        label={<Msg.EmployeesYes />}
      />

      <RadioButtonRow
        inputProps={{
          checked: willHaveEmployees === 'YES_ME',
          onChange: () => onChange('YES_ME'),
          name: 'willHaveEmployees',
        }}
        id="willHaveEmployeesYesN"
        label={
          <Msg.EmployeeYesN
            kind={ownershipType === 'single' ? 'single' : 'multiple'}
          />
        }
      />
    </>
  );
};
